export default "__VITE_ASSET__dqw234Kp__"